/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneIcon20Solid = forwardRef('SendPaperplaneIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M17.445 8.685 4.443 2.203a1.175 1.175 0 0 0-1.677 1.28l.95 4.82c.108.55.591.948 1.153.948h4.94a.75.75 0 1 1 0 1.5H4.87c-.562 0-1.045.397-1.154.947l-.95 4.812a1.175 1.175 0 0 0 1.678 1.28l13.002-6.475c1.085-.54 1.085-2.09 0-2.63Z" })));
});
